import React, { useState } from 'react';

import { COLOR_BLACK } from 'client/components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import {
  MarketingFAQContainer,
  MarketingFAQDetails,
  MarketingFAQSVG,
  MarketingFAQSummary,
  MarketingFAQTitle,
} from './styles';

type QuestionProps = {
  answer: string;
  bulletColor: string;
  question: string;
};

type FAQType = {
  answer: string;
  question: string;
};

type MarketingFAQProps = {
  bulletColor?: string;
  FAQList: FAQType[];
  title?: string;
};

function Question({ answer, bulletColor, question }: QuestionProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MarketingFAQDetails
      key={`glossary-${question}`}
      // @ts-ignore - `onToggle` seems to be missing from the types
      onToggle={e => {
        setIsOpen(e.target.open);
      }}
    >
      <MarketingFAQSummary>
        <MarketingFAQSVG
          viewBox="0 0 16 16"
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden={true}
        >
          <circle cx="8" cy="8" r="8" fill={bulletColor} />
          <rect x="3" y="7" width="10" height="2" rx="1" fill="#fff" />
          {isOpen ? null : (
            <rect x="7" y="3" width="2" height="10" rx="1" fill="#fff" />
          )}
        </MarketingFAQSVG>
        {question}
      </MarketingFAQSummary>
      {answer}
    </MarketingFAQDetails>
  );
}

export function MarketingFAQ({
  bulletColor = COLOR_BLACK,
  FAQList,
  title,
}: MarketingFAQProps) {
  const t = useT();
  const fallbackTitle = t(
    'MarketingFAQ.Title',
    'FAQ',
    'FAQ marketing page section title'
  );

  return (
    <MarketingFAQContainer>
      <MarketingFAQTitle>{title || fallbackTitle}</MarketingFAQTitle>
      {FAQList.map(({ question, answer }) => {
        return (
          <Question
            bulletColor={bulletColor}
            question={question}
            answer={answer}
            key={`glossary-${question}`}
          />
        );
      })}
    </MarketingFAQContainer>
  );
}
